import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { getOrderPrint } from '../Helper/order';
import "./BillStyles.css";

const PrintBill = () => {
 const [data, setData] = useState(null);
 const { Id } = useParams();
 const location = useLocation();

 useEffect(() => {
  if (Id) {
   getOrderPrint(Id).then((res) => {
    if (res && typeof res === 'string' && res.trim()) {
     const parser = new DOMParser();
     const doc = parser.parseFromString(res, 'text/html');

     // Extract data from HTML
     const header = doc.querySelector('.header');
     const orderId = header ? header.querySelector('p:nth-child(2)').textContent.split(':')[1].trim() : '';
     const customerText = header ? header.querySelector('p:nth-child(3)').textContent.split(':')[1].trim() : '';
     const customerName = customerText.split(' (')[0];
     const customerPhone = customerText.split(' (')[1]?.replace(')', '') || '';
     const orderDate = header ? header.querySelector('p:nth-child(4)').textContent.split(':')[1].trim() : '';

     const table = doc.querySelector('table');
     const rows = table ? table.querySelectorAll('tbody tr') : [];
     const orderItems = Array.from(rows).map((row, index) => {
      const cells = row.querySelectorAll('td');
      return {
       item: cells[0]?.textContent.trim() || '',
       type: cells[1]?.textContent.trim() || '',
       charges: cells[2]?.textContent.trim() || ''
      };
     });

     const totalDiv = doc.querySelector('.total');
     const totalCharges = totalDiv ? totalDiv.querySelector('p:first-child').textContent.split(':')[1].trim() : '';
     const preOrderTotalCharges = totalDiv && totalDiv.querySelector('p:nth-child(2)') ? totalDiv.querySelector('p:nth-child(2)').textContent.split(':')[1].trim() : '';

     const qrImg = doc.querySelector('img[alt="barcode"]');
     const qrCode = qrImg ? qrImg.src.split(',')[1] : null;

     const extractedData = {
      orderId,
      customerName,
      customerPhone,
      orderDate,
      orderItems,
      totalCharges,
      preOrderArray: [], // Not present in HTML, set empty
      preOrderTotalCharges,
      qrCode
     };

     setData(extractedData);
     setTimeout(() => {
      window.print();
     }, 1000);
    } else {
     setData(null);
    }
   }).catch((error) => {
    console.error('API call failed:', error);
    setData(null);
   });
  } else if (location.state && location.state.printData) {
   setData(location.state.printData);
   setTimeout(() => {
    window.print();
   }, 1000);
  }
 }, [Id, location.state]);

 if (!data) {
  return <div>Loading...</div>;
 }

 return (
  <div>
   <div className="ticket " style={{ fontFamily: "Times New Roman", fontSize: "9px", minWidth: "219.21259843" }} >
    <div className="text-center">
     <strong style={{ textAlign: "center", marginBlock: "5px", fontSize: "12px" }}>CP LASER SOLDERING</strong>
    </div>
    <hr className="m-0" style={{ borderTop: "10px solid !important" }} />
    Order Id : <b className="">{data.orderId} </b><br />
    Order Date : <b className="">{data.orderDate} </b>
    <hr className="m-0" style={{ borderTop: "10px dotted !important" }} />
    <span style={{ margin: "2px", padding: "0" }}>Name : <b className=""> {data.customerName?.replace(/,\s*$/, '').trim()} </b></span>
    <br /><span style={{ margin: "2px", padding: "0" }}>Contact No. : <b className="">{data.customerPhone ?? ""} </b></span>
    <hr className="m-0" style={{ borderTop: "10px dotted !important" }} />
    <table className="table" style={{ width: "100%" }}>
     <tr>
      <td className='text-center' colSpan={4}>........................................................................................</td>
     </tr>
     <tr>
      <th scope="col" className="quantity" style={{ textAlign: "left" }}>Sr.</th>
      <th scope="col" className="description" style={{ textAlign: "left" }}>Items</th>
      <th scope="col" className="description" style={{ textAlign: "left" }}>Type</th>
      <th scope="col" className="price" style={{ textAlign: "left" }}>₹</th>
     </tr>
     <tr>
      <td className='text-center' colSpan={4}>........................................................................................</td>
     </tr>

     {data.orderItems?.map((item, index) => {
      return (
       <tr key={index}>
        <td className="quantity">{index + 1}</td>
        <td className="description" style={{ textTransform: "capitalize" }}>{item.item}</td>
        <td className="description" style={{ textTransform: "capitalize" }}>{item.type}</td>
        <td className="">{item.charges}</td>
       </tr>
      )
     })}
     <tr>
      <td className='text-center' colSpan={4}>........................................................................................</td>
     </tr>

     <tr>
      <td className="quantity"></td>
      <td className="quantity"></td>
      <td className="description">Total</td>
      <td className="price me-0">{data.totalCharges}</td>
     </tr>
    </table>
    ........................................................................................            <br />
    <b className="">Previous Outstanding </b><br /><br />
    <table className='table' style={{ width: "100%" }}>
     <tr>
      <td className="quantity">Sr</td>
      <td className="quantity">OID</td>
      <td className="description"></td>
      <td className="price">₹</td>
     </tr>
     <tr>
      <td className='text-center' colSpan={4}>........................................................................................</td>
     </tr>
     {
      data.preOrderArray?.map((item, index) => {
       return <>

        <tr>
         <td className="quantity">{index + 1}</td>
         <td className="quantity">{item.orderId}</td>
         <td className="description">R.AMOUNT</td>
         <td className="price">{item.remainingAmount}</td>
        </tr>
        <tr>
         <td className='text-center' colSpan={4}>........................................................................................</td>
        </tr>
       </>
      })
     }
     <tr>
      <td className="quantity"></td>
      <td className="quantity"></td>
      <td className="description">G.TOTAL</td>
      {/* <td className="description">Previous Orders Remaining</td> */}
      <td className="price">{data.preOrderTotalCharges}</td>
     </tr>
     <tr>
      <td className='text-center' colSpan={4}>........................................................................................</td>
     </tr>
     <tr>
      <td className='text-center' colSpan={4}>Thanks for Purchase !</td>
     </tr>
    </table>
    {data.qrCode && (
     <div style={{ textAlign: 'center', marginTop: '10px' }}>
      <img src={`data:image/png;base64,${data.qrCode}`} alt="QR Code" style={{ width: '100px', height: '100px' }} />
     </div>
    )}
   </div>
  </div>
 );
}

export default PrintBill;
